// API Configuration - Dynamically determine URLs based on current host
// IMPORTANT: These functions MUST be called at runtime (in browser), not at build time
// Do NOT use process.env.REACT_APP_* here as they are evaluated at build time

// Get username from URL or localStorage (for auth)
const getUsername = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlUser = urlParams.get('user');
  if (urlUser && urlUser !== 'Guest') {
    localStorage.setItem('username', urlUser);
    return urlUser;
  }
  return localStorage.getItem('username');
};

// Helper to add user parameter to URL for fetch calls (axios has interceptor, fetch doesn't)
export const addUserParam = (url) => {
  const username = getUsername();
  if (!username) return url;

  try {
    const urlObj = new URL(url, window.location.origin);
    if (!urlObj.searchParams.has('user')) {
      urlObj.searchParams.set('user', username);
    }
    return urlObj.toString();
  } catch (e) {
    return url;
  }
};

export const getApiUrl = () => {
  // Always use runtime detection - do NOT check process.env here
  // as React inlines those values at build time

  const host = window.location.hostname;
  const protocol = window.location.protocol;

  // Production: spreads.eigentrage.com (via nginx proxy)
  if (host === 'spreads.eigentrage.com') {
    return 'https://spreads.eigentrage.com/api';
  }

  // Other eigentrage subdomains (via nginx proxy)
  if (host.endsWith('.eigentrage.com')) {
    return `${protocol}//${host}/api`;
  }

  // Local development
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:3003/api';
  }

  // LAN access: use same host with backend port
  return `http://${host}:3003/api`;
};

export const getWsUrl = () => {
  // Always use runtime detection
  const host = window.location.hostname;
  const isSecure = window.location.protocol === 'https:';

  // Production: spreads.eigentrage.com (via nginx proxy)
  if (host === 'spreads.eigentrage.com') {
    return 'wss://spreads.eigentrage.com/ws';
  }

  // Other eigentrage subdomains (via nginx proxy)
  if (host.endsWith('.eigentrage.com')) {
    return `${isSecure ? 'wss' : 'ws'}://${host}/ws`;
  }

  // Local development
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'ws://localhost:3003/ws';
  }

  // LAN access: use same host with backend port
  return `ws://${host}:3003/ws`;
};
